<h1 mat-dialog-title>
	<span [translate]="'admin.frais.indemnites.fraisMissions.detail.duplication.titre'"></span>
	<span [mat-dialog-close]><i class="zmdi zmdi-close"></i></span>
</h1>

<div mat-dialog-content>
	<card-alerte [niveau]="NiveauAlerte.WARNING">
		<preview-alerte [alerte]="alerte"></preview-alerte>
	</card-alerte>

	<form #duplicationForm="ngForm">
		<div class="row">
			<div class="col-md-6">
				<div class="row">
					<custom-input ngDefaultControl
								  id="duplicationTerritoire"
								  name="duplicationTerritoire"
								  [(ngModel)]="selectedGeographie"
								  customType="autocomplete"
								  autocompleteType="geographie"
								  [autocompleteFilter]="{ listeTypes: ['PAYS', 'VILLE', 'ZONE', 'REGION'] }"
								  optionDisplay="libelle"
								  [lCol]="5"
								  [rCol]="6"
								  libelle="admin.frais.indemnites.fraisMissions.detail.generalites.territoire"
								  [required]="true"
								  [readonly]="isTauxSpecialFromTerritoire"
								  (onChange)="onTerritoireChange($event)">
					</custom-input>
					<button *ngIf="!isTauxSpecialFromTerritoire"
							mat-icon-button
							class="territoire-search-btn"
							type="button"
							(click)="openTerritoirePopin()"
							[matTooltip]="'admin.frais.indemnites.fraisMissions.detail.generalites.rechercheAvancee' | translate">
						<mat-icon>manage_search</mat-icon>
					</button>
				</div>

				<div class="row flex-nowrap">
					<custom-input ngDefaultControl
								  id="duplicationPeriodeMin"
								  name="duplicationPeriodeMin"
								  [(ngModel)]="fraisMissionForm.periodeMin"
								  (ngModelChange)="onFieldChange()"
								  customType="number"
								  [lCol]="5"
								  [rCol]="2"
								  libelle="admin.frais.indemnites.fraisMissions.detail.generalites.periodeValidite"
								  [required]="true"
								  [min]="1"
								  rClass="periode-input-small">
					</custom-input>

					<div class="col-auto px-2 pt-3">
						<span [translate]="'admin.frais.indemnites.fraisMissions.detail.generalites.periodeA'"></span>
					</div>

					<custom-input ngDefaultControl
								  id="duplicationPeriodeMax"
								  name="duplicationPeriodeMax"
								  [(ngModel)]="fraisMissionForm.periodeMax"
								  (ngModelChange)="onFieldChange()"
								  customType="number"
								  [rCol]="2"
								  [lCol]="0"
								  rClass="periode-input-small">
					</custom-input>

					<div class="col-auto px-2 pt-3">
                    <span>
                        <span [translate]="'admin.frais.indemnites.fraisMissions.detail.generalites.periodeJours'"></span>
                        <mat-icon class="material-icons-outlined ml-2" style="vertical-align: middle; font-size: 18px;"
								  [matTooltip]="'admin.frais.indemnites.fraisMissions.detail.generalites.periodeTooltip' | translate">
                            info
                        </mat-icon>
                    </span>
					</div>
				</div>
			</div>
			<div class="col-md-6">
				<div class="row">
					<custom-input ngDefaultControl
								  id="duplicationHasTauxSpecial"
								  name="duplicationHasTauxSpecial"
								  [ngModel]="fraisMissionForm.hasTauxSpecial"
								  [(customModel)]="fraisMissionForm.hasTauxSpecial"
								  (ngModelChange)="onTauxSpecialChange()"
								  customType="checkbox"
								  [lCol]="4"
								  [rCol]="8"
								  libelle="admin.frais.indemnites.fraisMissions.detail.generalites.tauxSpecial"
								  postLibelle="admin.frais.indemnites.fraisMissions.detail.generalites.tauxSpecialPostLibelle">
					</custom-input>
				</div>

				<div class="row">
					<custom-input ngDefaultControl
								  id="duplicationLibelleSpecial"
								  name="duplicationLibelleSpecial"
								  [(ngModel)]="fraisMissionForm.libelleSpecial"
								  (ngModelChange)="onFieldChange()"
								  customType="input"
								  [lCol]="4"
								  [rCol]="6"
								  libelle="admin.frais.indemnites.fraisMissions.detail.generalites.libelleTauxSpecial"
								  [required]="fraisMissionForm.hasTauxSpecial"
								  [disabled]="!fraisMissionForm.hasTauxSpecial"
								  [postTooltipNio]="{content: ('admin.frais.indemnites.fraisMissions.detail.generalites.libelleTauxSpecialTooltip' | translate)}">
					</custom-input>
				</div>
			</div>
		</div>
	</form>
</div>
<div mat-dialog-actions align="end">
	<button mat-flat-button color="primary" (click)="onSave()" [disabled]="!(canSave$ | async)">
		<span [translate]="'global.actions.enregistrer'"></span>
	</button>
</div>